var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.files.length > 0)?_c('span',[_vm._v(_vm._s(_vm.files.length)+" fichiers ("+_vm._s(_vm._f("fileSize")(_vm.files.reduce((acc, event) => acc += event.size, 0)))+")")]):_c('span',[_vm._v("Pas de pièce jointe")])])
}
var staticRenderFns = []

export { render, staticRenderFns }